@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('featuredFileUrl')) {
        @if (isNotNil(model.featuredFileUrl)) {
          <app-image-thumbnail>
            <img
              [ngSrc]="model.featuredFileUrl"
              [fill]="true"
              [alt]="model.featuredFileAlt"
              class="object-contain" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported />
        }
      }

      @case (getColumnKey('status')) {
        <app-admin-box-sale-status [status]="model.status" />
      }

      @case (getColumnKey('isContentPublic')) {
        {{ model.isContentPublic ? 'Tak' : 'Nie' }}
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
